import React from 'react';
export function BotanicalLeaf({
  className = ''
}: {
  className?: string;
}) {
  return <svg viewBox="0 0 100 200" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} data-id="element-25">
      <path d="M50 200 C 50 150, 50 100, 50 0" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" data-id="element-26" />
      <path d="M50 150 C 75 140, 95 115, 95 85 C 75 85, 50 110, 50 150" stroke="currentColor" strokeWidth="1.5" fill="transparent" data-id="element-27" />
      <path d="M50 120 C 25 110, 5 85, 5 55 C 25 55, 50 80, 50 120" stroke="currentColor" strokeWidth="1.5" fill="transparent" data-id="element-28" />
      <path d="M50 80 C 70 70, 85 50, 85 25 C 70 25, 50 45, 50 80" stroke="currentColor" strokeWidth="1.5" fill="transparent" data-id="element-29" />
      <path d="M50 50 C 30 40, 15 20, 15 -5 C 30 -5, 50 15, 50 50" stroke="currentColor" strokeWidth="1.5" fill="transparent" data-id="element-30" />
    </svg>;
}